import React from 'react';
import styled from 'styled-components';
import { Transition } from 'react-transition-group';
import { useInView } from 'react-intersection-observer';
import PropTypes from 'prop-types';

const propTypes = {
  direction: PropTypes.string,
  onScroll: PropTypes.bool,
  trigger: PropTypes.bool,
  delay: PropTypes.number,
  children: PropTypes.any.isRequired,
  threshold: PropTypes.number
};

/**
 * Returns the css translation for a given animation direction
 *
 * @function getTransformation
 * @returns {string} The css translate function
 * @param {string} direction the direction the item should animate
 * @param {string} state the animation state of the item
 */
const getTransformation = (direction, state) => {
  let axis = 'Y';
  let distance = 24;

  if (direction === 'left' || direction === 'right') {
    axis = 'X';
  }

  if (state === 'entered' || direction === 'none') {
    distance = 0;
  } else if (direction === 'down' || direction === 'right') {
    distance = -distance;
  }

  return `translate${axis}(${distance}px);`;
};

const AnimateIn = props => {
  const { children, delay = 0, direction = 'up', onScroll = false, trigger = false, threshold = 0.05 } = props;
  const [ref, inView] = useInView({ threshold: threshold, triggerOnce: true });

  return (
    <Transition in={onScroll ? inView : trigger} timeout={100} exit={false}>
      {state => (
        <Fade state={state} ref={ref} direction={direction} delay={delay}>
          {children}
        </Fade>
      )}
    </Transition>
  );
};

const Fade = styled.div`
  transition: opacity 1s ease, transform 1.2s ease;
  transition-delay: ${({ delay }) => delay}ms;
  transform: ${({ direction, state }) => getTransformation(direction, state)};
  opacity: ${({ state }) => (state === 'entered' ? '1' : '0')};
`;

AnimateIn.propTypes = propTypes;

export { AnimateIn };
